import styled from 'styled-components'

export const NavBar = styled.nav`
background: linear-gradient(to bottom right, var(--color-terciary), #c0a898);
  text-shadow: var(--text-border-dark);
`
